import { faqSchema } from '../../../constants/componentStaticData';
import { If } from '../../Atoms/Conditionals';
import { Accordion } from '../../Molecules/accordion';
import {
  getExpandedState,
  getVariantClasses,
  getVariantClassesDetail,
  getVariantClassesHeader,
} from './utils';

export type TexpandedState = 'firstOnly' | 'true' | 'false';

export enum FaqVariants {
  default = 'default',
  partner = 'partner',
  calculator = 'calculator',
  itrGuide = '',
}

export type TFAQs = Array<{
  header: string;
  content: React.ReactElement | string;
}>;

interface faqInterface {
  FAQS: TFAQs;
  heading?: string;
  expanded?: TexpandedState;
  variant?: keyof typeof FaqVariants;
  faqIconColor?: string;
  isShowSchema?: boolean;
  htmlFromApi?: boolean;
  parentClass?: string;
}

export const FaqComponent = ({
  FAQS,
  heading = 'Frequently Asked Questions',
  expanded = 'true',
  variant = 'default',
  faqIconColor = '#9092A3',
  isShowSchema = false,
  htmlFromApi = false,
  parentClass = 'pt-6 pb-6 sm:pt-14 sm:py-10 sm:w-full',
}: faqInterface): JSX.Element => {
  if (!FAQS.length) return <></>;

  return (
    <div className={parentClass}>
      <h2
        className={`${
          heading ? '' : 'hidden'
        } faq-title text-s-24 pb-7 m-0 sm:pb-3 sm:text-s-20 sm:leading-7 sm:font-bold`}
      >
        {heading}
      </h2>
      {FAQS.map((item, idx) => {
        const content = htmlFromApi ? (
          <div dangerouslySetInnerHTML={{ __html: item.content }} />
        ) : (
          item.content
        );

        return (
          <Accordion
            key={idx}
            className={`${getVariantClasses(variant)} `}
            header={item.header}
            isExpandedState={getExpandedState(expanded, idx)}
            detailPanelClasses={getVariantClassesDetail(variant)}
            accordianHeaderEleClasses={getVariantClassesHeader(variant)}
            iconColor={faqIconColor}
          >
            {content}
          </Accordion>
        );
      })}

      <If condition={isShowSchema}>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqSchema(FAQS)),
          }}
        ></script>
      </If>
    </div>
  );
};
